import { Radio as ChakraRadio, RadioProps } from '@chakra-ui/react';
import React, { FC } from 'react';

export const Radio: FC<RadioProps> = ({ ...props }) => {
  return <ChakraRadio fontFamily="Helvetica Neue" {...props}></ChakraRadio>;
};
